import type { TourStep } from "@/components/GuidedTour";

export const partnersTourSteps: TourStep[] = [
  {
    target: "",
    title: "Our Network",
    titleAr: "شبكتنا",
    description: "Fusion connects you to 4600 faces across 6 media partners — indoor, outdoor, premium and programmatic.",
    descriptionAr: "تربطك فيوجن بـ 4600 شاشة عبر 6 شركاء إعلاميين — داخلية وخارجية، مميزة وبرمجية.",
  },
  {
    target: "partners-hero",
    title: "Premium Partners",
    titleAr: "شركاء مميزون",
    description: "Each partner is hand-picked for reach, quality, and audience fit across the Kingdom's busiest venues.",
    descriptionAr: "كل شريك مُختار بعناية للوصول والجودة وملاءمة الجمهور في أبرز المواقع في المملكة.",
  },
  {
    target: "partners-grid",
    title: "Indoor & Outdoor",
    titleAr: "داخلية وخارجية",
    description: "Switch between Indoor and Outdoor tabs to compare networks. Click any partner to see locations, formats, and a media kit.",
    descriptionAr: "بدّل بين تبويبات الداخلية والخارجية لمقارنة الشبكات. انقر أي شريك لعرض المواقع والصيغ والملف الإعلامي.",
  },
  {
    target: "partners-cta",
    title: "Advertise With Us",
    titleAr: "أعلن معنا",
    description: "Ready to go live? Start a campaign and book any partner's faces directly through Fusion — no broker calls needed.",
    descriptionAr: "جاهز للانطلاق؟ ابدأ حملة واحجز شاشات أي شريك مباشرة عبر فيوجن — دون الحاجة إلى وسطاء.",
  },
];
